import {
  Authority,
  AuthorityDetail,
  AuthorityDetailFromJSON,
  AuthorityDetailTag,
  AuthorityDetailTagFromJSON,
  AuthorityFromJSON,
  AuthorityList,
  AuthorityListFromJSON,
  BibliographyList,
  BibliographyListFromJSON,
  CreateAuthorityRequest,
  CreateAuthorityRequestToJSON,
  DeleteAuthorityRequest,
  DeleteAuthorityRequestToJSON,
  GetAuthorityListRequest,
  GetAuthorityListRequestToJSON,
  GetAuthorityRequest,
  GetAuthorityRequestToJSON,
  GetAuthorityTagListRequest,
  GetAuthorityTagListRequestToJSON,
  GetBibliographyListRequest,
  GetBibliographyListRequestToJSON,
  HTTPQuery,
  IntegrateAuthorityRequest,
  IntegrateAuthorityRequestToJSON,
  SearchAuthorityRequest,
  SearchAuthorityRequestToJSON,
  UpdateAuthorityNormalRequest,
  UpdateAuthorityNormalToJSON,
  UpdateAuthorityRequest,
  UpdateAuthorityRequestToJSON,
  UpdateAuthoritySubRequest,
  UpdateAuthoritySubRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class AuthorityApi extends runtime.BaseAPI {
  /**
   * 典拠を検索する
   * 典拠検索
   */
  async searchAuthority(request: SearchAuthorityRequest): Promise<Authority[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchAuthorityRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/authority/search', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityFromJSON)
    ).value()
  }

  /**
   * 典拠を削除する
   * 典拠削除
   */
  async deleteAuthority(
    request: DeleteAuthorityRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteAuthorityRequestToJSON(
      request
    )
    const response = await this.requestDelete('/authority', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 典拠を取得する
   * 典拠取得
   */
  async getAuthority(request: GetAuthorityRequest): Promise<AuthorityDetail> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetAuthorityRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/authority', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuthorityDetailFromJSON(jsonValue)
    ).value()
  }

  /**
   * 典拠統一形を更新する
   * 典拠統一形更新
   */
  async updateAuthorityNormal(
    request: UpdateAuthorityNormalRequest
  ): Promise<string> {
    const bodyParameters: runtime.HTTPBody = UpdateAuthorityNormalToJSON(
      request
    )
    const response = await this.requestPut('/authority/normal', bodyParameters)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.authority_no
    ).value()
  }

  /**
   * 典拠従属形を更新する
   * 典拠従属形更新
   */
  async updateAuthoritySub(
    request: UpdateAuthoritySubRequest
  ): Promise<string> {
    const bodyParameters: runtime.HTTPBody = UpdateAuthoritySubRequestToJSON(
      request
    )
    const response = await this.requestPut('/authority/sub', bodyParameters)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.authority_no
    ).value()
  }

  /**
   * 典拠一覧を取得する
   * 典拠一覧取得
   */
  async getAuthorityList(
    request: GetAuthorityListRequest
  ): Promise<AuthorityList[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetAuthorityListRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/authority/authority-list',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityListFromJSON)
    ).value()
  }

  /**
   * 典拠一覧を取得する
   * 典拠一覧取得
   */
  async getBibliographyList(
    request: GetBibliographyListRequest
  ): Promise<BibliographyList[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetBibliographyListRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/authority/bibliography-list',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BibliographyListFromJSON)
    ).value()
  }

  /**
   * 典拠を統合する
   * 典拠統合
   */
  async integrateAuthority(
    request: IntegrateAuthorityRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = IntegrateAuthorityRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/authority/integrate',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 典拠を更新する
   * 典拠更新
   */
  async updateAuthority(
    request: UpdateAuthorityRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateAuthorityRequestToJSON(
      request
    )
    const response = await this.requestPut('/authority', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 典拠を作成する
   * 典拠作成
   */
  async createAuthority(request: CreateAuthorityRequest): Promise<string> {
    const bodyParameters: runtime.HTTPBody = CreateAuthorityRequestToJSON(
      request
    )
    const response = await this.requestPost('/authority', bodyParameters)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.authority_no
    ).value()
  }

  /**
   * 典拠タグを取得する
   * 典拠タグ取得
   */
  async getAuthorityTagList(
    request: GetAuthorityTagListRequest
  ): Promise<AuthorityDetailTag[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetAuthorityTagListRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/authority/tags', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AuthorityDetailTagFromJSON)
    ).value()
  }
}
